import type { ShopIdentity } from "../lib/shop.js";
import "./Closed.css";

export default function Closed({ shop }: { shop: ShopIdentity }) {
  return (
    <main className="wrap closed">
      <h1 className="closed__name">{shop.name}</h1>
      <p className="closed__message">
        We are not taking orders online right now. Please check back soon.
      </p>
      {shop.phone && shop.phoneHref && (
        <a className="closed__phone" href={`tel:${shop.phoneHref}`}>
          Call {shop.phone}
        </a>
      )}
    </main>
  );
}
